export type ClassDictionary = Record<string, unknown>;
export type ClassArray = ClassValue[];
export type ClassValue = ClassArray | ClassDictionary | string | null | boolean | undefined;

function toVal(mix: ClassValue): string {
  if (typeof mix === 'string') {
    return mix;
  }

  if (Array.isArray(mix)) {
    return mix.filter(Boolean).map(toVal).filter(Boolean).join(' ');
  }

  if (typeof mix === 'object' && mix !== null) {
    return Object.keys(mix as ClassDictionary)
      .filter(key => Boolean((mix as ClassDictionary)[key]))
      .join(' ');
  }

  return '';
}

export function cn(...inputs: ClassValue[]): string {
  return inputs.filter(Boolean).map(toVal).filter(Boolean).join(' ');
}
